import type { Profile } from 'models';
import { useMemo } from 'react';

export const useBadgeNotificationSettings = ({ viewer }: { viewer: Profile }) =>
  useMemo(
    () => ({
      enableNotifications: viewer.badgeNotificationsSettings.enableNotifications?.value ?? false,
    }),
    [viewer.badgeNotificationsSettings.enableNotifications?.value],
  );
